import { createStyles, makeStyles } from 'transfix-ui/core'
import { calcRem } from 'transfix-ui/theme/typography'
import { brandColors } from 'transfix-ui'

const textStyles = {
  fontSize: calcRem(12),
  color: brandColors.coolGray5,
}

export const useTrackingLocationStyles = makeStyles(theme =>
  createStyles({
    textSmall: textStyles,
    textCaption: {
      ...textStyles,
      fontWeight: theme.typography.fontWeightBold,
      color: brandColors.coolGray8,
    },
    textBold: {
      fontWeight: theme.typography.fontWeightBold,
    },
    textSecondary: {
      color: brandColors.coolGray5,
    },
    status: {
      marginBottom: theme.spacing(1),
      marginTop: theme.spacing(1),
    },
    trackingLogo: {
      width: calcRem(26),
    },
    subContent: {
      display: 'flex',
      alignItems: 'center',
      gap: calcRem(12),
      paddingTop: theme.spacing(1),
      paddingBottom: theme.spacing(1),
    },
    separator: {
      borderTop: `1px solid ${brandColors.coolGray4}`,
    },
    succesIconMargin: {
      marginRight: theme.spacing(1),
    },
  })
)
